module.exports = __webpack_public_path__ + "static/media/5-Hearts.795466f8.svg";